export const createIdAriaDescribedBy = label => {
  let id;
  if (label) {
    id = label
      .split(" ")
      .join("-")
      .toLowerCase();
  }
  return id ? `${id}-a11` : null;
};
